import { render } from "./SearchResults.vue?vue&type=template&id=7b2d7c26&ts=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__